import { useMutation, useQueryClient } from "react-query"
import Network from "../../network"

export default function useAdminLogin() {

    const client = useQueryClient()

    const {mutate, isLoading, error} = useMutation((data: {password: string}) => {
        return Network.adminLogin(data);
    }, {
        onSuccess: () => {
            client.invalidateQueries('config');
        }
    })

    return {
        adminLogin: mutate,
        isLoading,
        error
    }
}
